import classNames from "classnames";
import DateTimeInput from "../../../../../form/DateTimeInput";
import React from "react";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems} = props;
    const dateFields = ["issuedate", "transactiondate", "deadline", "accountdate"];
    return (hidden || []).indexOf("transactiondate") === -1 && <div className={classNames("col-sm-" + (12 / (dateFields.length-(hidden || []).filter((h) => dateFields.indexOf(h) !== -1).length)))}>
        <DateTimeInput name="transactiondate"
                   label="Teljesítés dátuma"
                   {...props.getProps("transactiondate")}
                   value={props.getValue("transactiondate")}
                   showTime={false} saveChanges={props.setFieldValue}/>
    </div>;
}